module.exports = __webpack_public_path__ + "static/media/complot-poster.c8f60ea4.png";